import { ChatComponentType } from '@common/hooks/useChatComponentActions';

export const DEFAULT_PAGINATION = { limit: 10, skip: 0, total: 0 };
export const MAX_FILES_COUNT = 5; // maximum upload 5 files in a messages
export const MAX_INPUT_LENGTH = 2000;
export const isPCView = (width: number) => width > 768;
export const PC_WIDTH_GROUP_MESSAGE_VIEW = 325;
export const CHAT_DUMMY_DATA: {
  ChatGroup: ChatComponentType.GroupMessageTypeWithMessageJson[];
  ChatMessages: ChatComponentType.ChatMessagesTypeWithMessageJson[];
  UnReadGroupStatus: Record<string, number>;
} = {
  ChatGroup: [
    {
      id: '1',
      latestMessage: {
        id: '0',
        message: {
          text: 'テキストが入りますテキストが入りますテキストが入ります',
        },
        senderAvatar: {
          url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_1.png',
        },
        senderId: '1',
        senderName: 'ユーザー名',
        createdAt: '2025-01-01 12:00:00',
      },
      groupName: 'ユーザー名',
      groupImage: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
      },
      numberOfUsers: 1,
    },
    {
      id: '2',
      latestMessage: {
        id: '0',
        message: {
          text: 'テキストが入りますテキストが入りますテキストが入ります',
        },
        senderAvatar: {
          url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_2.jpeg',
        },
        senderId: '2',
        senderName: 'ユーザー名',
        createdAt: '2025-02-04 12:00:00',
      },
      groupName: 'ユーザー名',
      groupImage: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_2.jpeg',
      },
      numberOfUsers: 2,
    },
    {
      id: '3',
      latestMessage: {
        id: '0',
        message: {
          text: 'テキストが入りますテキストが入りますテキストが入ります',
        },
        senderAvatar: {
          url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_3.jpeg',
        },
        senderId: '3',
        senderName: 'ユーザー名',
        createdAt: '2025-02-13 12:00:00',
      },
      groupName: 'ユーザー名',
      groupImage: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
      },
      numberOfUsers: 3,
    },
    {
      id: '4',
      latestMessage: {
        id: '0',
        message: {
          text: 'テキストが入りますテキストが入りますテキストが入ります',
        },
        senderAvatar: {
          url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_4.jpeg',
        },
        senderId: '3',
        senderName: 'ユーザー名',
        createdAt: '2025-02-14 12:00:00',
      },
      groupName: 'ユーザー名',
      groupImage: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
      },
      numberOfUsers: 100,
    },
  ],
  UnReadGroupStatus: {
    '1': 1,
    '2': 100,
    '3': 56,
  },
  ChatMessages: [
    {
      id: '1',
      message: {
        text: 'テキストが入りますテキストが入りますテキストが入りますテキストが入りますテキストが入ります',
        files: [
          {
            url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
            type: 'image/png',
            filename: 'example_avatar_1.png',
          },
          {
            url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
            filename: 'file1.docx',
            type: 'application/text',
          },
          {
            url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
            filename: 'file2_super_long_long_long.docx',
            type: 'application/text',
          },
          {
            url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
            type: 'image/jpeg',
            filename: 'example_avatar_4.jpeg',
          },
        ],
      },
      senderAvatar: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_4.jpeg',
      },
      senderId: '2',
      senderName: 'ユーザー名',
      createdAt: '2025/02/03 12:30:00',
      groupId: '1',
    },
    {
      id: '2',
      message: {
        text: 'テキストが入ります',
        files: [
          {
            url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
            filename: 'file1.docx',
            type: 'application/text',
          },
          {
            url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/logo.png',
            type: 'application/text',
            filename: 'file2_super_long_long_long.docx',
          },
        ],
      },
      senderAvatar: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_4.jpeg',
      },
      senderId: '2',
      senderName: 'ユーザー名',
      createdAt: '2025/02/03 12:32:00',
      groupId: '1',
    },
    {
      id: '3',
      message: {
        text: 'テキストが入ります',
      },
      senderAvatar: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_1.png',
      },
      senderId: '1',
      senderName: 'ユーザー名',
      createdAt: '2025/02/03 15:00:00',
      groupId: '1',
    },
    {
      id: '4',
      message: {
        text: 'テキストが入ります',
      },
      senderAvatar: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_4.jpeg',
      },
      senderId: '2',
      senderName: 'ユーザー名',
      createdAt: '2025/02/03 15:00:00',
      groupId: '1',
    },
    {
      id: '5',
      message: {
        text: 'テキストが入りますテキストが入りますテキストが入りますテキストが入りますテキストが入りますテキストが入りますテキストが入りますテキスト',
      },
      senderAvatar: {
        url: 'https://click-assets.s3.ap-northeast-1.amazonaws.com/example_avatar_1.png',
      },
      senderId: '1',
      senderName: 'ユーザー名',
      createdAt: '2025/02/03 13:24:00',
      groupId: '1',
    },
  ],
};
export const FILE_BACKGROUND_URL =
  'https://click-assets.s3.ap-northeast-1.amazonaws.com/file_placeholder.png';
export const DEFAULT_AVATAR_URL =
  'https://click-assets.s3.ap-northeast-1.amazonaws.com/default_avatar.jpeg';
export const FILE_UPLOADING_TYPE = 'FILE_UPLOADING_TYPE';
export const FILE_UPLOADING: ChatComponentType.FileType = {
  filename: 'Uploading...',
  type: FILE_UPLOADING_TYPE,
  url: FILE_BACKGROUND_URL,
};
export const getUrlRegex = () => new RegExp(/(https?:\/\/[^\s]+)/g);

export const getNumberOverflow = (
  value?: number,
  options?: { digit: number }
) => {
  const { digit } = options || { digit: 2 };
  if (value === undefined || Number.isNaN(Number(value))) {
    return undefined;
  }
  const maxNumber = Math.pow(10, digit);
  if (value >= maxNumber) {
    return `${maxNumber - 1}+`;
  }
  return `${value}`;
};

export const isNumberOfUserDisplayed = ({
  numberOfUsers,
}: {
  numberOfUsers?: number;
}) => {
  return numberOfUsers ? Number(numberOfUsers) !== 2 : false;
};
